import React from 'react'
import App from './v1/App'

import './v1/assets/css/normalize.css'
import './v1/assets/css/fonts.css'
import './v1/assets/css/icons.css'
import './v1/assets/css/globals.css'

const Theme = props => (
  <App />
)

export default Theme
